import Vue from 'vue'
import { getMatchedComponentsInstances, promisify, globalHandleError } from './utils'
import NuxtLoading from './components/nuxt-loading.vue'

import _6f6c098b from '../app/layouts/default.vue'
import _7762b8c6 from '../app/layouts/guide.vue'
import _baf1fb1e from '../app/layouts/orderComplete.vue'
import _1a3b299f from '../app/layouts/top.vue'

const layouts = { "_default": _6f6c098b,"_guide": _7762b8c6,"_orderComplete": _baf1fb1e,"_top": _1a3b299f }

export default {
  head: {"title":"スナップスナップ - スクールフォト販売サイト","titleTemplate":"%s | スナップスナップ - スクールフォト販売サイト","htmlAttrs":{"lang":"ja"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"スナップスナップは、こどもたちの生き生きとした瞬間を『カタチ＝写真』にしてお届けするサービスです。"},{"hid":"keyword","name":"keyword","content":"スナップスナップ,snapsnap,イベント,撮影,プロカメラマン,写真,プリント,販売,学校,幼稚園,保育園,こども園"},{"hid":"read-aloud","name":"google","content":"nopagereadaloud"},{"hid":"og:site_name","property":"og:site_name","content":"スナップスナップ - スクールフォト販売サイト"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fsnapsnap.jp"},{"hid":"og:title","property":"og:title","content":"スナップスナップ"},{"hid":"og:description","property":"og:description","content":"スナップスナップは、こどもたちの生き生きとした瞬間を『カタチ＝写真』にしてお届けするサービスです。"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fsnapsnap.jp\u002Fstatic\u002Fogp\u002Fsnapsnap.jpg"},{"hid":"google-site-verification","name":"google-site-verification","content":"sGhsU1TuK5lvTqLI9bVEuhCrjECnq_MX9IS6OGkCwqo"}],"link":[{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"\u002Fstatic\u002Ficon\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-180x180.png","sizes":"192x192"},{"rel":"apple-touch-icon","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-180x180.png"}],"script":[{"src":"https:\u002F\u002Fpolyfill.io\u002Fv3\u002Fpolyfill.min.js?features=Element.prototype.classList%2Ces2016%2Ces2017%2Ces2015%2CPromise%2CPromise.prototype.finally"},{"src":"https:\u002F\u002Fsecurepubads.g.doubleclick.net\u002Ftag\u002Fjs\u002Fgpt.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5MZV9TS')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5MZV9TS&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },
    async refresh() {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()
      const promises = pages.map(async (page) => {
        const p = []

        if (page.$options.fetch) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }
        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail()
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
